import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useYandexMetrika(counterId) {
    const location = useLocation();

    useEffect(() => {
        if (window.ym) {
            // отправляем «виртуальный» хит Метрике
            window.ym(counterId, 'hit', location.pathname + location.search);
        }
    }, [location, counterId]);
}
